import PropTypes from 'prop-types';
import React from 'react';
import WowModal from './WowModal';

const GpsrPopup = ({ deal, setShowProductInfo, showProductInfo }) => {
  if (!deal) return null;

  return (
    <>
      <WowModal
        ariaLabelledBy=""
        centered
        keyboard={false}
        setShowModal={setShowProductInfo}
        showCloseButton
        showModal={showProductInfo}
      >
        <div className="popup-content">
          {deal?.gpsrManufacturerName && (
            <>
              <h3>Manufacturer Information</h3>
              <br />
              <p>
                <strong>Name: </strong> {deal.gpsrManufacturerName}
              </p>
              <p>
                <strong>Address: </strong> {deal.gpsrManufacturerPostalAddress}
              </p>
              <p>
                <strong>Email Address: </strong>{' '}
                {deal.gpsrManufacturerContactEmail}
              </p>
            </>
          )}

          {deal?.gpsrManufacturerName && deal?.euResponsiblePersonName && (
            <>
              <hr className="divider" />
            </>
          )}

          {deal?.euResponsiblePersonName && (
            <>
              <h3>EU Responsible Person Information</h3>
              <br />
              <p>
                <strong>Name: </strong> {deal.euResponsiblePersonName}
              </p>
              <p>
                <strong>Address: </strong> {deal.euResponsiblePersonAddress}
              </p>
              <p>
                <strong>Email Address: </strong> {deal.euResponsiblePersonEmail}
              </p>
            </>
          )}
        </div>
      </WowModal>
      <style jsx>{`
        .popup-content {
          width: 100%;
          margin-top: -30px;
          padding: 5px;
          position: relative;
          word-wrap: break-word;
        }
        h3 {
          text-align: center;
        }
        p {
          text-align: left;
          margin-left: 10px;
        }
        .divider {
          border: none;
          border-top: 1px solid #ccc;
          margin: 16px 0;
        }
      `}</style>
    </>
  );
};

GpsrPopup.propTypes = {
  deal: PropTypes.shape({
    euResponsiblePersonAddress: PropTypes.string,
    euResponsiblePersonEmail: PropTypes.string,
    euResponsiblePersonName: PropTypes.string,
    gpsrManufacturerContactEmail: PropTypes.string,
    gpsrManufacturerName: PropTypes.string,
    gpsrManufacturerPostalAddress: PropTypes.string,
  }),
  setShowProductInfo: PropTypes.func,
};

GpsrPopup.defaultProps = {
  deal: null,
};

export default GpsrPopup;
